import React, { useState, useEffect, useReducer } from 'react'
import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Checkbox from '@mui/material/Checkbox'
import Chip from '@mui/material/Chip'
import DeleteIcon from '@mui/icons-material/Delete'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import GetExternalSource from './GetExternalSource'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import InputLabel from '@mui/material/InputLabel'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Select from '@mui/material/Select'
import SourcePropertiesWizard from './SourcePropertiesWizard'
import Stack from '@mui/material/Stack'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

function AxesDefinition(props) {
    const [dataSourceType, setDataSourceType] = useState(0)
    const [dimensions, setDimensions] = useState([])
    const [errors, setErrors] = useState([])
    const [selectedElement, setSelectedElement] = useState({ "id": -2, "type": -2, "segmentName": "", "ranges": [], "outputFormat": [] })
    const [currentTab, setCurrentTab] = useState(0)
    const [tabData, setTabData] = useState([])
    const [externalTabData, setExternalTabData] = useState([])
    const [selectedDimensionType, setSelectedDimensionType] = useState(0)
    const [selectedColumns, setSelectedColumns] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const [selectedIndividualCells, setSelectedIndividualCells] = useState([])
    const [rangeType, setRangeType] = useState('fixed')
    const [namedColumns, setNamedColumns] = useState(false)
    const [headerRow, setHeaderRow] = useState(0)
    const [outputFormatOptions, setOutputFormatOptions] = useState([])
    const [selectedRangeIndex, setSelectedRangeIndex] = useState(-1)
    const [sourcePropertiesOpen, setSourcePropertiesOpen] = useState(false)
    const [externalCellOpen, setExternalCellOpen] = useState(false)
    const [tableHasHeader, setTableHasHeader] = useState(false)
    const [factsColumnRanges, setFactsColumnRanges] = useState([])
    const [, forceUpdate] = useReducer(x => x + 1, 0)

    const NEW_DIMENSION = "New Dimension"
    const NEW_SEGMENT = "New Segment"
    const MEASURES = "Measures"

    // trigger on component mount
    useEffect(() => {
        setTabData(props.previewData)
        setNamedColumns(props.tableDefinition.namedColumns)
        setHeaderRow(props.headerRow)
        setExternalTabData(props.externalTabData)
        setTableHasHeader(props.tableHasHeader)
        setFactsColumnRanges(props.factsColumnRanges)

        if (props.tableDefinition.namedColumns) {
            setRangeType('name')
        }

        if (props.dimensions && props.dimensions.length !== dimensions.length) {
            callSetDimensions(props.dimensions)
        } else {
            buildNewDimensionArrayFromDropdown(0)
        }
    }, [])

    useEffect(() => {
        setNamedColumns(props.tableDefinition.namedColumns)

        if (props.tableDefinition.namedColumns) {
            setRangeType('name')
        }
    }, [props.tableDefinition.namedColumns])

    useEffect(() => {
        if (props.headerRow !== headerRow) {
            setHeaderRow(props.headerRow)
        }
    }, [props.headerRow])

    useEffect(() => {
        if (props.dimensions && props.dimensions.length !== dimensions.length) {
            callSetDimensions(props.dimensions)
            callSetDataSourceType(props.dimensions)
        }
    }, [props.dimensions])

    useEffect(() => {
        if (props.tableHasHeader !== tableHasHeader) {
            setTableHasHeader(props.tableHasHeader)
        }
    }, [props.tableHasHeader])

    useEffect(() => {
        if (props.externalTabData.length !== externalTabData.length) {
            setExternalTabData(props.externalTabData)
        }
    }, [props.externalTabData])

    /**
     * buildNewDimensionArrayFromDropdown
     * * Build the skeleton dimension array based on the drop down
     * @param {int} dsType - Data source type
    */
    function buildNewDimensionArrayFromDropdown(dsType) {
        let rtnVal = []
        rtnVal.push({ "id": -1, "type": -1, "name" : MEASURES, "segments": [], "ranges": [], "outputFormat": [] })

        if (dsType === 0) {
            rtnVal.push({ "id": 1, "type": 1, "name" : "Product", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 2, "type": 2, "name" : "Time Period", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 3, "type": 3, "name" : "Geography", "segments": [], "ranges": [], "outputFormat": [] })
        } else if (dsType === 1) {
            rtnVal.push({ "id": 1, "type": 1, "name" : "Product", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 2, "type": 2, "name" : "Time Period", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 3, "type": 3, "name" : "Geography", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 4, "type": 4, "name" : "Demographics", "segments": [], "ranges": [], "outputFormat": [] })
        } else if (dsType === 2) {
            rtnVal.push({ "id": 1, "type": 1, "name" : "Product", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 2, "type": 2, "name" : "Time Period", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 3, "type": 3, "name" : "Geography", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 4, "type": 4, "name" : "Demographics", "segments": [], "ranges": [], "outputFormat": [] })
            rtnVal.push({ "id": 5, "type": 5, "name" : "Breakout", "segments": [], "ranges": [], "outputFormat": [] })
        }

        callSetDimensions(rtnVal)
        if (props.onSave) {
            props.onSave(rtnVal)
        }
    }

    /**
     * changeDimensionName
     * * Change the name of a dimension
     * @param {int} index - Index of dimension in the collection
     * @param {string} newName - Changed name of the dimension
    */
    function changeDimensionName(index, newName) {
        let copied = dimensions

        if (isThereAnyDimensionAlreadyWithThisName(newName)) {
            let copiedErrors = errors
            copiedErrors.push(`Dimension with the name [${newName}] already exists`)
            setErrors(copiedErrors)
        }

        copied[index]["name"] = newName
        callSetDimensions(copied)
        if (props.onSave) {
            props.onSave(copied)
        }

        forceUpdate()
    }

    /**
     * addNewDimension
     * * Event of the "New Dimension" button click
     * @param {any} event - Front end event from the control
    */
    function addNewDimension(event) {
        event.preventDefault()
        let copied = dimensions

        if (isThereAnyDimensionAlreadyWithThisName(NEW_DIMENSION)) {
            let copiedErrors = errors
            copiedErrors.push(`Dimension with the name [${NEW_DIMENSION}] already exists`)
            setErrors(copiedErrors)
        }
        
        copied.push({ "id": copied.length + 1, "type": 0, "name" : NEW_DIMENSION, "segments": [], "ranges": [], "outputFormat": [] })
        callSetDimensions(copied)
        if (props.onSave) {
            props.onSave(copied)
        }

        setSelectedRangeIndex(-1)
        forceUpdate()
    }

    /**
     * addNewSegmentToDimension
     * * Adding a brand new segment to the given dimension
     * @param {int} atIndex - 
    */
    function addNewSegmentToDimension(atIndex) {
        let copied = dimensions

        if (isThereAnySegmentWithinThisDimensionAlreadyWithThisName(atIndex, NEW_SEGMENT)) {
            let copiedErrors = errors
            copiedErrors.push(`Dimension '${copied[atIndex]["name"]}' already has a segment named [${NEW_SEGMENT}]`)
            setErrors(copiedErrors)
        }
        
        copied[atIndex]["segments"].push({ "name": NEW_SEGMENT, "ranges": [], "outputFormat": []  })
        callSetDimensions(copied)
        if (props.onSave) {
            props.onSave(copied)
        }

        forceUpdate()
    }

    /**
     * updateSelectedColumns
     * * When a user makes a selection, check some things and then set the new values
     * @param {int} index - What index was selected
    */
    function updateSelectedColumns(index) {
        let needToInsert = true
        let foundIndex = -1
        let copiedSelectedColumns = selectedColumns

        for (let x = 0; x < selectedColumns.length; x++) {
            if (selectedColumns[x] === index) {
                needToInsert = false
                foundIndex = x
            }
        }

        if (needToInsert) {
            copiedSelectedColumns.push(index)
            setSelectedRows([])
        } else if (foundIndex > -1) {
            copiedSelectedColumns.splice(foundIndex, 1);
        }

        setSelectedColumns(copiedSelectedColumns)
    }

    /**
     * updateIndividualCellSelections
     * * When a non column header or row checkbox is clicked
    */
    function updateIndividualCellSelections(rowIndex, colIndex) {
        let copiedSelectedIndividualCells = selectedIndividualCells
        let updated = []
        let needsToAdd = true

        for (let x = 0; x < copiedSelectedIndividualCells.length; x++) {
            if (copiedSelectedIndividualCells[x]["row"] !== rowIndex || copiedSelectedIndividualCells[x]["column"] !== colIndex) {
                updated.push(copiedSelectedIndividualCells[x])
            } else {
                needsToAdd = false
            }
        }

        if (needsToAdd) {
            updated.push({ "row": rowIndex, "column": colIndex })
        }

        setSelectedIndividualCells(updated)
    }

    /**
     * updateSelectedDimensionType
     * * Find the selected element and change the type to what was selected
     * @param {int} updatedType - Type ID we are updating to
    */
    function updateSelectedDimensionType(updatedType) {
        let copiedDimensions = dimensions
        let copiedSelectedElement = selectedElement

        copiedSelectedElement["type"] = updatedType

        for (let x = 0; x < copiedDimensions.length; x++) {
            if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                copiedDimensions[x]["type"] = updatedType
            }
        }
        setSelectedElement(copiedSelectedElement)
        callSetDimensions(copiedDimensions)
        if (props.onSave) {
            props.onSave(copiedDimensions)
        }
    }

    /**
     * changeSegmentName
     * * Changing the segment name of a given dimension
     * @param {int} dimensionIndex - Dimension index
     * @param {object} dimension - Dimension data
     * @param {int} segmentIndex - Segment index
     * @param {string} newName - Name of the segment
    */
    function changeSegmentName(dimensionIndex, dimension, segmentIndex, newName) {
        let copied = dimensions
        
        if (isThereAnySegmentWithinThisDimensionAlreadyWithThisName(dimensionIndex, newName)) {
            let copiedErrors = errors
            copiedErrors.push(`Dimension '${copied[dimensionIndex]["name"]}' already has a segment named [${newName}]`)
            setErrors(copiedErrors)
        }
        
        copied[dimensionIndex]["segments"][segmentIndex]["name"] = newName
        callSetDimensions(copied)
        setSelectedElement({ "id": dimension["id"], "type": dimension["type"], "segmentName": newName, "ranges": copied[dimensionIndex]["segments"][segmentIndex]["ranges"], "outputFormat": copied[dimensionIndex]["segments"][segmentIndex]["outputFormat"] })
        
        if (props.onSave) {
            props.onSave(copied)
        }
        
        forceUpdate()
    }

    /**
     * removeDimensionAtIndex
     * * Removing a dimension from a specific index in the UI
     * @param {int} index - Index to remove
    */
    function removeDimensionAtIndex(index) {
        let copied = []

        for (let x = 0; x < dimensions.length; x++) {
            if (x !== index) {
                copied.push(dimensions[x])
            }
        }

        callSetDimensions(copied)
        if (props.onSave) {
            props.onSave(copied)
        }
    }

    /**
     * removeSegmentFromDimensionAtIndex
     * * Within a dimension, remove a segment at specific index
     * @param {int} dimensionIndex - Index of the dimension
     * @param {int} segmentIndex - Index of the segment within the dimension
    */
    function removeSegmentFromDimensionAtIndex(dimensionIndex, segmentIndex) {
        let copiedDimensions = dimensions
        let copiedSegments = []

        for (let x = 0; x < dimensions[dimensionIndex]["segments"].length; x++) {
            if (x !== segmentIndex) {
                copiedSegments.push(dimensions[dimensionIndex]["segments"][x])
            }
        }

        dimensions[dimensionIndex]["segments"] = copiedSegments

        callSetDimensions(copiedDimensions)

        if (props.onSave) {
            props.onSave(copiedDimensions)
        }

        forceUpdate()
    }

    /**
     * removeErorAtIndex
     * * Remove an error at a specfic index
     * @param {int} index - Index of error to remove 
    */
    function removeErorAtIndex(index) {
        let copied = []

        for (let x = 0; x < errors.length; x++) {
            if (x !== index) {
                copied.push(errors[x])
            }
        }

        setErrors(copied)
    }

    /**
     * isThereAnyDimensionAlreadyWithThisName
     * * Check all current dimensions to see if there is a matching name
     * @param {string} dimensionName - Dimension name
    */
    function isThereAnyDimensionAlreadyWithThisName(dimensionName) {
        let rtnVal = false

        for (let x = 0; x < dimensions.length; x++) {
            if (dimensions[x]["name"].toUpperCase() === dimensionName.toUpperCase()) {
                rtnVal = true
            }
        }

        return rtnVal
    }

    /**
     * isThereAnySegmentWithinThisDimensionAlreadyWithThisName
     * * Lookup to see if a specific dimension already has a segment with a specific name
     * @param {int} dimensionIndex - Index of the dimension
     * @param {string} newSegmentName - Name of the new segment
    */
    function isThereAnySegmentWithinThisDimensionAlreadyWithThisName(dimensionIndex, newSegmentName) {
        let rtnVal = false

        for (let x = 0; x < dimensions[dimensionIndex]["segments"].length; x++) {
            if (dimensions[dimensionIndex]["segments"][x]["name"].toUpperCase() === newSegmentName.toUpperCase()) {
                rtnVal = true
            }
        }

        return rtnVal
    }

    /**
     * renderDimensionPaper
     * * First level of the rendering for the individual dimensions
     * @param {Object} dimension - Dimension data
     * @param {int} index - Index of the array the dimension we are editing
    */
    function renderDimensionPaper(dimension, index) {
        let isThisDimensionEditable = (dimension["name"] !== MEASURES)

        if (isThisDimensionEditable) {
            return renderEditableDimension(dimension, index)
        } else {
            return renderUneditableDimension(dimension, index)
        }
    }

    function renderUneditableDimension(dimension, index) {
        return <Paper
            key={`dimension-paper-${index}`}
            sx={{
                "cursor": "pointer",
                "backgroundColor": (selectedElement["type"] === dimension["type"]) ? props.uiColors.FACT_COLUMN_HIGHLIGHT : props.uiColors.REGULAR
            }}
            onClick={() => {
                setSelectedElement({ "id": dimension["id"], "type": dimension["type"], "segmentName": "", "ranges": dimension["ranges"], "outputFormat": dimension["outputFormat"] })
                setSelectedDimensionType(dimension["type"])
                setSelectedColumns([])
                setOutputFormatOptions([])
                setSelectedRangeIndex(-1)
            }}>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <Typography>{dimension["name"]}</Typography>
                </Grid>
            </Grid>
        </Paper>
    }

    function renderEditableDimension(dimension, index) {
        return <Paper
            key={`dimension-paper-${index}`}>
            <Grid
                container
                spacing={0}
                sx={{
                    "cursor": "pointer",
                    "backgroundColor": (selectedElement["type"] === dimension["type"]) ? props.uiColors.FACT_COLUMN_HIGHLIGHT : props.uiColors.REGULAR
                }}>
                <Grid item xs={10}>
                    <TextField
                        value={dimension["name"]}
                        variant="standard"
                        sx={{ "width": "100%" }}
                        onClick={() => {
                            setSelectedElement({ "id": dimension["id"], "type": dimension["type"], "segmentName": "", "ranges": dimension["ranges"], "outputFormat": dimension["outputFormat"] })
                            setSelectedDimensionType(dimension["type"])
                            setSelectedColumns([])
                            setSelectedRangeIndex(-1)

                            let newOptionsToSet = []
                            for (let x = 0; x < dimension["ranges"].length; x++) {
                                newOptionsToSet.push(`(${dimension["ranges"][x]["name"]})`)
                            }
                            setOutputFormatOptions(newOptionsToSet)
                        }}
                        onChange={(event) => {
                            event.preventDefault()
                            changeDimensionName(index, event.target.value)
                        }}>
                    </TextField>
                </Grid>
                <Grid item xs={2}>
                    <ButtonGroup variant="outlined" aria-label="Basic button group" size="small" fullWidth>
                        <IconButton aria-label="Add Segment" size="small" onClick={(e) => {
                            e.preventDefault()
                            addNewSegmentToDimension(index)
                        }}>
                            <AddIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton aria-label="Add Segment" size="small" onClick={(e) => {
                            e.preventDefault()
                            removeDimensionAtIndex(index)
                            setSelectedElement({ "id": -2, "type": -2, "segmentName": "", "ranges": [], "outputFormat": [] })
                            setSelectedDimensionType(0)
                        }}>
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </ButtonGroup>
                </Grid>
            </Grid>
            {dimension["segments"].map((segmentData, segmentIndex) => {
                return <Grid
                    container
                    spacing={0}
                    key={`dimension-paper-${index}-segment-${segmentIndex}`}
                    sx={{
                        "cursor": "pointer",
                        "paddingLeft": "10px",
                        "backgroundColor": (selectedElement["type"] === dimension["type"] && selectedElement["segmentName"] === segmentData["name"]) ? props.uiColors.FACT_COLUMN_HIGHLIGHT : props.uiColors.REGULAR
                    }}>
                    <Grid item xs={11}>
                        <TextField
                            value={segmentData["name"]}
                            variant="standard"
                            sx={{ "width": "100%" }}
                            onClick={() => {
                                setSelectedElement({ "id": dimension["id"], "type": dimension["type"], "segmentName": segmentData["name"], "ranges": segmentData["ranges"], "outputFormat": segmentData["outputFormat"] })
                                setSelectedDimensionType(dimension["type"])
                                setSelectedColumns([])
                                setSelectedRangeIndex(-1)
                                forceUpdate()
                            }}
                            onChange={(event) => {
                                event.preventDefault()
                                changeSegmentName(index, dimension, segmentIndex, event.target.value)
                            }}>
                    </TextField>
                    </Grid>
                    <Grid item xs={1}>
                        <ButtonGroup variant="outlined" aria-label="Basic button group" size="small" fullWidth>
                            <IconButton aria-label="Delete Segment" size="small" onClick={(e) => {
                                e.preventDefault()
                                removeSegmentFromDimensionAtIndex(index, segmentIndex)
                                setSelectedElement({ "id": -2, "type": -2, "segmentName": "", "ranges": [], "outputFormat": [] })
                                setSelectedDimensionType(0)
                            }}>
                                <DeleteIcon fontSize="inherit" />
                            </IconButton>
                        </ButtonGroup>
                    </Grid>
                </Grid>
            })}
        </Paper>
    }

    function renderTableOrMessageStatingNothingWasSelected() {
        if (tabData.length > 0) {
            return <Tabs value={currentTab} onChange={(event, newValue) => setCurrentTab(newValue)} aria-label="Preview Data Tabs" variant="scrollable">
                {tabData.map((tab, index) => {return <Tab key={`tab-data-${index}`} label={tab["tabName"]} {...a11yProps(index)} />})}
            </Tabs>
        }

        return null
    }

    /**
     * renderSelectedPreviewDataPanel
     * * Rander the tabed area with the preview snapshot of the data
    */
    function renderSelectedPreviewDataPanel() {
        if (tabData.length > currentTab) {
            return <TableContainer component={Paper} style={{ overflowY: "none", "cursor": "default", "height": "550px" }}>
                <Table size="small" aria-label="preview data">
                    <TableHead>
                        <TableRow  sx={{"cursor": "pointer"}}>
                            <TableCell>{' '}</TableCell>
                            {tabData[currentTab].previewData[0].map((tabInfo, tabInfoIndex) => {
                                return <TableCell
                                    key={`row-excel-header-${tabInfoIndex}`}
                                    align="center"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        
                                        updateSelectedColumns(tabInfoIndex)
                                        setSelectedIndividualCells([])
                                        setSelectedRows([])
                                        forceUpdate()
                                }}>
                                    {props.getExcelColumnName(tabInfoIndex + 1)}
                                </TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tabData[currentTab].previewData.map((tabInfo, tabInfoIndex) => {
                            return ((tableHasHeader && props.doesThisRowHaveDataInEverySingleColumn(tabInfo)) || !tableHasHeader) ? <TableRow
                                key={`tab-${currentTab}-row-${tabInfoIndex}`}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell padding="checkbox">
                                        <FormControlLabel
                                            control={<Checkbox
                                                color="primary"
                                                checked={selectedRows.includes(tabInfoIndex)}
                                                onChange={(e) => {
                                                    let copied = selectedRows
                                                    
                                                    if (e.target.checked) {
                                                        copied.push(tabInfoIndex)
                                                        setSelectedIndividualCells([])
                                                        setSelectedColumns([])
                                                    } else {
                                                        let indexToRemove = copied.indexOf(tabInfoIndex);
                                                        if (indexToRemove !== -1) {
                                                            copied.splice(indexToRemove, 1);
                                                        }
                                                    }

                                                    setSelectedRows(copied)
                                                    forceUpdate()
                                                }}
                                                inputProps={{
                                                    'aria-label': 'select row',
                                                }}/>
                                            }
                                            label={(tabInfoIndex-getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData))+1}
                                        />
                                    </TableCell>
                                    {renderPreviewRow(tabInfo, tabInfoIndex, currentTab, tableHasHeader, tabData[currentTab].previewData)}
                            </TableRow> : null
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        }

        return null
    }

    /** 
     * renderPreviewRow
     * * Render the row on the preview data tab
     * @param {Array} tabInfo - Preview Data
     * @param {int} rowIndex - Current row index
    */
    function renderPreviewRow(tabInfo, rowIndex, tabIndex, hasHeader, tabData) {
        return tabInfo.map((data, index) => {
            return <TableCell
                key={`tab-${tabIndex}-row-${rowIndex}-cell-${index}`}
                align="center"
                style={{
                    "backgroundColor" : isThisCellSelected(selectedColumns, selectedIndividualCells, rowIndex, index) ? props.uiColors.GRID_HIGHLIGHT : props.uiColors.REGULAR
                }}
                onClick={(e) => {
                    e.preventDefault()

                    updateIndividualCellSelections(rowIndex, index)
                    setSelectedColumns([])
                    setSelectedRows([])
                    forceUpdate()
            }}>
                {data}
            </TableCell>
        })
    }

    /**
     * removeRangeFromSelectedSelementAtIndex
     * * Result of the "Trash" icon button pressed for a column range
    */
    function removeRangeFromSelectedSelementAtIndex(index) {
        let copiedSelectedElement = selectedElement
        let rangeToDelete = copiedSelectedElement["ranges"][index]
        let copiedRangesArray = []
        let copiedOutputFormat = []
        let copiedOutputFormatOptions = []

        for (let x = 0; x < copiedSelectedElement["ranges"].length; x++) {
            if (x !== index) {
                copiedRangesArray.push(copiedSelectedElement["ranges"][x])
            }
        }

        for (let y = 0; y < copiedSelectedElement["outputFormat"].length; y++) {
            if (!copiedSelectedElement["outputFormat"][y].includes(rangeToDelete["name"])) {
                copiedOutputFormat.push(copiedSelectedElement["outputFormat"][y])
                copiedOutputFormatOptions.push(copiedSelectedElement["outputFormat"][y])
            }
        }

        copiedSelectedElement["ranges"] = copiedRangesArray
        copiedSelectedElement["outputFormat"] = copiedOutputFormat
        setSelectedElement(copiedSelectedElement)
        setOutputFormatOptions(copiedOutputFormatOptions)

        // Change overall dimensions array
        let isDimensionSelected = (copiedSelectedElement["segmentName"] === "")
        let copiedDimensions = dimensions

        if (isDimensionSelected) {
            for (let x = 0; x < copiedDimensions.length; x++) {
                if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                    copiedDimensions[x]["ranges"] = copiedRangesArray
                    copiedDimensions[x]["outputFormat"] = copiedOutputFormat
                }
            }
        }  else {
            for (let x = 0; x < copiedDimensions.length; x++) {
                if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                    for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                        if (copiedDimensions[x]["segments"][y]["name"] === copiedSelectedElement["segmentName"]) {
                            copiedDimensions[x]["segments"][y]["ranges"] = copiedSelectedElement["ranges"]
                            copiedDimensions[x]["segments"][y]["outputFormat"] = copiedSelectedElement["outputFormat"]
                        }
                    }
                }
            }
        }

        callSetDimensions(copiedDimensions)
        if (props.onSave) {
            props.onSave(copiedDimensions)
        }
    }

    /**
     * isThisCellSelected
     * * Determines if the cell needs to be highlighted as selected or not
     * @param {int[]} cols - Entire columns
     * @param {Array} cells - Individual Cells
     * @param {int} rowIndex - Cell row
     * @param {int} colIndex - Cell column
     * @returns {bool} True is the row needs to be highlighted
    */
    function isThisCellSelected(cols, cells, rowIndex, colIndex) {
        if (cols && cols.includes(colIndex)) {
            return true
        }

        for (let x = 0; x < cells.length; x++) {
            if (cells[x]["row"] === rowIndex && cells[x]["column"] === colIndex) {
                return true
            }
        }

        return false
    }

    /**
     * changeRangeUseProperCase
     * * Change the 'Use Proper Case' checkbox status of a given range
     * @param {int} rangeIndex - Index of the range within the collection
     * @param {boolean} checkedStatus - Is the box checked?
    */
    function changeRangeUseProperCase(rangeIndex, checkedStatus) {
        let isDimensionSelected = (selectedElement["segmentName"] === "")
        let copiedSelectedElement = selectedElement
        let copiedDimensions = dimensions

        if (isDimensionSelected) {
            for (let x = 0; x < copiedDimensions.length; x++) {
                if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                    copiedDimensions[x]["ranges"][rangeIndex]["useProperCase"] = checkedStatus
                    copiedSelectedElement["ranges"][rangeIndex]["useProperCase"] = checkedStatus
                }
            }
        } else {
            for (let x = 0; x < copiedDimensions.length; x++) {
                if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                    for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                        if (copiedDimensions[x]["segments"][y]["name"] === copiedSelectedElement["segmentName"]) {
                            copiedSelectedElement["ranges"][rangeIndex]["useProperCase"] = checkedStatus
                            copiedDimensions[x]["segments"][y]["ranges"][rangeIndex]["useProperCase"] = checkedStatus
                        }
                    }
                }
            }
        }

        setSelectedElement(copiedSelectedElement)
        callSetDimensions(copiedDimensions)
        if (props.onSave) {
            props.onSave(copiedDimensions)
        }
    }

    /**
     * changeRangeUseNulls
     * * Change the 'Use Proper Case' checkbox status of a given range
     * @param {int} rangeIndex - Index of the range within the collection
     * @param {boolean} checkedStatus - Is the box checked?
    */
    function changeRangeUseNulls(rangeIndex, checkedStatus) {
        let isDimensionSelected = (selectedElement["segmentName"] === "")
        let copiedSelectedElement = selectedElement
        let copiedDimensions = dimensions

        if (isDimensionSelected) {
            for (let x = 0; x < copiedDimensions.length; x++) {
                if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                    copiedDimensions[x]["ranges"][rangeIndex]["useNulls"] = checkedStatus
                    copiedSelectedElement["ranges"][rangeIndex]["useNulls"] = checkedStatus
                }
            }
        } else {
            for (let x = 0; x < copiedDimensions.length; x++) {
                if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                    for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                        if (copiedDimensions[x]["segments"][y]["name"] === copiedSelectedElement["segmentName"]) {
                            copiedSelectedElement["ranges"][rangeIndex]["useNulls"] = checkedStatus
                            copiedDimensions[x]["segments"][y]["ranges"][rangeIndex]["useNulls"] = checkedStatus
                        }
                    }
                }
            }
        }

        setSelectedElement(copiedSelectedElement)
        callSetDimensions(copiedDimensions)
        if (props.onSave) {
            props.onSave(copiedDimensions)
        }
    }

    function callSetDimensions(dims) {
        if (dims.length < 4) {
            let copiedErrors = errors
            copiedErrors.push('Must have at least 3 dimensions + measures')
            setErrors(copiedErrors)
        }

        setDimensions(dims)
    }

    function callSetDataSourceType(dims) {
        const productDimensionIn = dims.filter(d => d.type === 1).length > 0
        const timePeriodDimensionIn = dims.filter(d => d.type === 2).length > 0
        const geographyDimensionIn = dims.filter(d => d.type === 3).length > 0
        const allStandardDimensionsIn = productDimensionIn && timePeriodDimensionIn && geographyDimensionIn

        const demographicsDimensionIn = dims.filter(d => d.type === 4).length > 0
        const breakOutDimensionIn = dims.filter(d => d.type === 5).length > 0

        if (breakOutDimensionIn && demographicsDimensionIn && allStandardDimensionsIn) {
            setDataSourceType(2)
        } else if (demographicsDimensionIn && allStandardDimensionsIn) {
            setDataSourceType(1)
        } else if (allStandardDimensionsIn) {
            setDataSourceType(0)
        } else {
            setDataSourceType(-1)
        }
    }

    /**
     * getTabsRowOffset
     * * 
     * @param {boolean} hasHeader - Do the tables have a header? 
     * @param {Array} tabPreviewData - Preview data from the source 
     * @returns {int} First row header
     */
    function getTabsRowOffset(hasHeader, tabPreviewData) {
        // Only run this if we determine the table has a header
        if (hasHeader) {
            for (let x = 0; x < tabPreviewData.length; x++) {
                if (props.doesThisRowHaveDataInEverySingleColumn(tabPreviewData[x])) {
                    return x
                }
            }
        }

        return 0
    }

    return <>
        {/* First grouping, fixed and named column ranges */}
        <FormGroup>
            <RadioGroup
                row
                name="radio-buttons-group"
                onChange={(e) => {
                    setRangeType(e.target.value)
                }}
            >
                <FormControlLabel value="fixed" control={<Radio disabled={!namedColumns} checked={rangeType==='fixed'} />} label="Fixed" />
                {namedColumns === true ? <FormControlLabel value="name" control={<Radio checked={rangeType==='name'} />} label="Named" /> : null}
            </RadioGroup>
        </FormGroup>
        {/* Top grouping, the elements that make the bulk of the control */}
        <Grid container spacing={2} sx={{ "height": "90%" }}>
            {/* Data source type dimensions and segments */}
            <Grid item xs={2}>
                <FormControl className="field" fullWidth sx={{ "marginTop": "25px" }}>
                    <InputLabel id="data-source-type-label">Data Source Type</InputLabel>
                    <Select
                        labelId="data-source-type-label"
                        id="data-source-type"
                        label="Data Source Type"
                        onChange={(e) => {
                            e.preventDefault()
                            setDataSourceType(e.target.value)
                            buildNewDimensionArrayFromDropdown(e.target.value)
                        }}
                        value={dataSourceType}
                        required
                        fullWidth>
                            <MenuItem value={-1}>Unknown</MenuItem>
                            <MenuItem value={0}>Standard</MenuItem>
                            <MenuItem value={1}>Demographics</MenuItem>
                            <MenuItem value={2}>Demographics &amp; Breakout</MenuItem>
                    </Select>
                </FormControl>
                {errors.map((data, index) => {
                    return <Alert variant="outlined" severity="warning" onClose={() => {
                        removeErorAtIndex(index)
                    }}>{data}</Alert>
                })}
                <Stack spacing={2} sx={{ "marginTop": "15px" }}>
                    {dimensions.map((dimension, dimensionIndex) => {
                        return renderDimensionPaper(dimension, dimensionIndex)
                    })}
                </Stack>
                <Box sx={{ "marginTop": "15px" }} component="div">
                    <Button sx={{ "width": "100%" }} variant="contained" onClick={addNewDimension}>New Dimension</Button>
                </Box>
            </Grid>
            {/* Dimension type and range definition controls */}
            <Grid item xs={2} sx={{ "height": "100%", "overflowY": "auto", "overflowX": "hidden" }}>
                <FormControl className="field" fullWidth sx={{ "marginTop": "25px" }}>
                    <InputLabel id="dimension-type-label">Dimension Type</InputLabel>
                    <Select
                        labelId="dimension-type-label"
                        id="dimension-type"
                        label="Dimension Type"
                        onChange={(e) => {
                            e.preventDefault()
                            setSelectedDimensionType(e.target.value)
                            updateSelectedDimensionType(e.target.value)
                        }}
                        value={selectedDimensionType}
                        required
                        disabled={selectedDimensionType===-1 && selectedElement["id"]===-1}
                        fullWidth>
                            <MenuItem value={0}>Unknown</MenuItem>
                            <MenuItem value={-1}>Measures</MenuItem>
                            <MenuItem value={1}>Product</MenuItem>
                            <MenuItem value={2}>Time Period</MenuItem>
                            <MenuItem value={3}>Geography</MenuItem>
                            <MenuItem value={4}>Demographics</MenuItem>
                            <MenuItem value={5}>Breakout</MenuItem>
                    </Select>
                </FormControl>
                <Stack
                    spacing={2}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ "marginTop": "15px" }}>
                        {selectedElement["ranges"].map((rangeData, rangeIndex) => {
                            return <Paper
                            key={`dimension-segment-range-${rangeIndex}`}
                            sx={{
                                "cursor": "pointer",
                                "backgroundColor": (selectedRangeIndex === rangeIndex) ? props.uiColors.FACT_COLUMN_HIGHLIGHT : props.uiColors.REGULAR,
                                "width": "100%"
                            }}
                            onClick={() => {
                                setSelectedRangeIndex(rangeIndex)
                            }}>
                            <Grid container spacing={0}>
                                <Grid item xs={10}>
                                    <Typography>{rangeData["name"]}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <ButtonGroup variant="outlined" aria-label="Basic button group" size="small" fullWidth>
                                        <IconButton aria-label="Add Segment" size="small" onClick={(e) => {
                                            e.preventDefault()
                                            removeRangeFromSelectedSelementAtIndex(rangeIndex)
                                            setSelectedElement({ "id": -2, "type": -2, "segmentName": "", "ranges": [], "outputFormat": [] })
                                            setSelectedDimensionType(0)
                                            forceUpdate()
                                        }}>
                                            <DeleteIcon fontSize="inherit" />
                                        </IconButton>
                                    </ButtonGroup>
                                </Grid>
                            </Grid>
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            checked={rangeData["useProperCase"]}
                                            onChange={(e) => {
                                                changeRangeUseProperCase(rangeIndex, e.target.checked)
                                                forceUpdate()
                                            }} />
                                    } 
                                    label="Use Proper Case" />
                            </Box>
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            checked={rangeData["useNulls"]}
                                            onChange={(e) => {
                                                changeRangeUseNulls(rangeIndex, e.target.checked)
                                                forceUpdate()
                                            }} />
                                    } 
                                    label="Use Nulls" />
                            </Box>
                        </Paper>
                        })}
                </Stack>
                <Box sx={{ "marginTop": "15px" }} component="div">
                    <Button sx={{ "width": "100%" }} variant="contained" onClick={(e) => {
                        if (selectedRangeIndex > -1) {
                            setSourcePropertiesOpen(true)
                        }
                    }}>Properties</Button>
                </Box>
            </Grid>
             {/* Buttons/Controls */}
            <Grid item xs={1}>
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                >
                    <IconButton
                        aria-label="Add Selected"
                        size="medium"
                        color="primary"
                        variant="solid"
                        disabled={externalTabData.length===0 || selectedElement["id"]===-2}
                        onClick={(e) => {
                            e.preventDefault()
                            setExternalCellOpen(true)
                    }}>
                        <KeyboardDoubleArrowUpIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                        aria-label="Add Selected"
                        size="medium"
                        color="primary"
                        variant="solid"
                        disabled={selectedElement["id"]===-2}
                        onClick={(e) => {
                            e.preventDefault()

                            // Change selected element data
                            let copiedSelectedElements = selectedElement
                            let copiedOutputFormatOptions = outputFormatOptions

                            // Add selected column ranges
                            for (let x = 0; x < selectedColumns.length; x++) {
                                if (rangeType === 'name') {
                                    let lookupHeader = getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData)
                                    let selectedHeader = tabData[currentTab]["previewData"][lookupHeader][selectedColumns[x]]
                                    copiedSelectedElements["ranges"].push({ "name": `NColumn:${selectedHeader}`, "rowIndex": -20, "colIndex": -20, "useNulls": false, "useProperCase": false, "extractor" : { "extractorType": "", "numberOfWords": 0, "inverse" : false, "after" : 0, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": -1 } })
                                    copiedSelectedElements["outputFormat"].push(`(NColumn:${selectedHeader})`)
                                    copiedOutputFormatOptions.push(`(NColumn:${selectedHeader})`)
                                } else {
                                    copiedSelectedElements["ranges"].push({ "name": `Column:${props.getExcelColumnName(selectedColumns[x] + 1)}`, "rowIndex": -20, "colIndex": selectedColumns[x], "useNulls": false, "useProperCase": false, "extractor" : { "extractorType": "", "numberOfWords": 0, "inverse" : false, "after" : 0, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": -1 } })
                                    copiedSelectedElements["outputFormat"].push(`(Column:${props.getExcelColumnName(selectedColumns[x] + 1)})`)
                                    copiedOutputFormatOptions.push(`(Column:${props.getExcelColumnName(selectedColumns[x] + 1)})`)
                                }
                            }

                            // Add individual cells
                            for (let x = 0; x < selectedIndividualCells.length; x++) {
                                copiedSelectedElements["ranges"].push({ "name": `PCell ${props.getExcelColumnName(selectedIndividualCells[x]["column"] + 1)}${selectedIndividualCells[x]["row"] + 1}`, "rowIndex": selectedIndividualCells[x]["row"], "colIndex": selectedIndividualCells[x]["column"], "useNulls": false, "useProperCase": false, "extractor" : { "extractorType": "", "numberOfWords": 0, "inverse" : false, "after" : 0, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": -1 } })
                                copiedSelectedElements["outputFormat"].push(`(PCell ${props.getExcelColumnName(selectedIndividualCells[x]["column"] + 1)}${selectedIndividualCells[x]["row"] + 1})`)
                                copiedOutputFormatOptions.push(`(PCell ${props.getExcelColumnName(selectedIndividualCells[x]["column"] + 1)}${selectedIndividualCells[x]["row"] + 1})`)
                            }

                            // Add rows
                            for (let x = 0; x < selectedRows.length; x++) {
                                let rowIndex = selectedRows[x]-getTabsRowOffset(tableHasHeader, tabData[currentTab].previewData)
                                copiedSelectedElements["ranges"].push({ "name": `Row:${rowIndex + 1}`, "rowIndex": rowIndex, "colIndex": -20, "useNulls": false, "useProperCase": false, "extractor" : { "extractorType": "", "numberOfWords": 0, "inverse" : false, "after" : 0, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": -1 } })
                                copiedSelectedElements["outputFormat"].push(`(Row:${rowIndex + 1})`)
                                copiedOutputFormatOptions.push(`(Row:${rowIndex + 1})`)
                            }

                            setSelectedElement(copiedSelectedElements)
                            setOutputFormatOptions(copiedOutputFormatOptions)

                            // Change overall dimensions array
                            let isDimensionSelected = (selectedElement["segmentName"] === "")
                            let copiedDimensions = dimensions

                            if (isDimensionSelected) {
                                for (let x = 0; x < copiedDimensions.length; x++) {
                                    if (copiedDimensions[x]["id"] === selectedElement["id"]) {
                                        copiedDimensions[x]["ranges"] = copiedSelectedElements["ranges"]
                                    }
                                }
                            } else {
                                for (let x = 0; x < copiedDimensions.length; x++) {
                                    if (copiedDimensions[x]["id"] === selectedElement["id"]) {
                                        for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                                            if (copiedDimensions[x]["segments"][y]["name"] === selectedElement["segmentName"]) {
                                                copiedDimensions[x]["segments"][y]["ranges"] = copiedSelectedElements["ranges"]
                                            }
                                        }
                                    }
                                }
                            }

                            callSetDimensions(copiedDimensions)
                            if (props.onSave) {
                                props.onSave(copiedDimensions)
                            }

                            // Reset any grid selections
                            setSelectedColumns([])
                            setSelectedRows([])
                            setSelectedIndividualCells([])
                    }}>
                        <ArrowBackIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                        aria-label="Add Selected"
                        size="medium"
                        color="primary"
                        variant="solid"
                        disabled={selectedElement["id"]===-2}
                        onClick={(e) => {
                            e.preventDefault()

                            // Change selected element data
                            let copiedSelectedElements = selectedElement
                            let copiedOutputFormatOptions = outputFormatOptions

                            // Add from table
                            copiedSelectedElements["ranges"].push({ "name": "From Table Name", "rowIndex": -20, "colIndex": -20, "useNulls": false, "useProperCase": false, "extractor" : { "extractorType": "", "numberOfWords": 0, "inverse" : false, "after" : 0, "occurrence": "", "regularExpressionTerm": "", "regularExpressionOutput": "", "extractionType": -1 } })
                            copiedSelectedElements["outputFormat"].push("(From Table Name)")
                            copiedOutputFormatOptions.push("(From Table Name)")

                            setSelectedElement(copiedSelectedElements)
                            setOutputFormatOptions(copiedOutputFormatOptions)

                            // Change overall dimensions array
                            let isDimensionSelected = (selectedElement["segmentName"] === "")
                            let copiedDimensions = dimensions

                            if (isDimensionSelected) {
                                for (let x = 0; x < copiedDimensions.length; x++) {
                                    if (copiedDimensions[x]["id"] === selectedElement["id"]) {
                                        copiedDimensions[x]["ranges"] = copiedSelectedElements["ranges"]
                                    }
                                }
                            } else {
                                for (let x = 0; x < copiedDimensions.length; x++) {
                                    if (copiedDimensions[x]["id"] === selectedElement["id"]) {
                                        for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                                            if (copiedDimensions[x]["segments"][y]["name"] === selectedElement["segmentName"]) {
                                                copiedDimensions[x]["segments"][y]["ranges"] = copiedSelectedElements["ranges"]
                                            }
                                        }
                                    }
                                }
                            }

                            callSetDimensions(copiedDimensions)
                            if (props.onSave) {
                                props.onSave(copiedDimensions)
                            }

                            // Reset any grid selections
                            setSelectedColumns([])
                            setSelectedRows([])
                            setSelectedIndividualCells([])
                    }}>
                        <KeyboardDoubleArrowLeftIcon fontSize="inherit" />
                    </IconButton>
                </Stack>
            </Grid>
             {/* Preview data tabs */}
            <Grid item xs={7} sx={{ "height": "100%", "overflowY": "auto", "overflowX": "auto" }}>
                {renderTableOrMessageStatingNothingWasSelected()}
                {renderSelectedPreviewDataPanel()}
            </Grid>
        </Grid>
        {/* Output format textbox */}
        <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ "marginTop": "3px" }}>
            <Grid item xs={1}>
                <Typography>Output Format:</Typography>
            </Grid>
            <Grid item xs={11}>
                <Autocomplete
                    multiple
                    id="output-format"
                    options={outputFormatOptions}
                    value={(selectedElement && selectedElement["outputFormat"]) ? selectedElement["outputFormat"] : []}
                    freeSolo
                    size="small"
                    isOptionEqualToValue={(option, value) => false}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                        ))
                    }
                    onChange={(e, newValue) => {
                        let copiedDimensions = dimensions
                        let copiedSelectedElement = selectedElement

                        for (let x = 0; x < copiedDimensions.length; x++) {
                            if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                                copiedDimensions[x]["outputFormat"] = newValue
                                copiedSelectedElement["outputFormat"] = newValue
                            }
                        }

                        callSetDimensions(copiedDimensions)
                        setSelectedElement(copiedSelectedElement)

                        if (props.onSave) {
                            props.onSave(copiedDimensions)
                        }

                        forceUpdate()
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="filled"
                            label="Output Format"
                            placeholder="Output Format" />
                    )}
                />
            </Grid>
        </Grid>
        <SourcePropertiesWizard
            previewData={tabData}
            externalTabData={externalTabData}
            open={sourcePropertiesOpen}
            selectedElement={selectedElement}
            selectedRangeIndex={selectedRangeIndex}
            tableHasHeader={tableHasHeader}
            currentTab={currentTab}
            factsColumnRanges={factsColumnRanges}
            doesThisRowHaveDataInEverySingleColumn={props.doesThisRowHaveDataInEverySingleColumn}
            onClose={() => {
                setSourcePropertiesOpen(false)
                setSelectedElement({ "id": -2, "type": -2, "segmentName": "", "ranges": [], "outputFormat": [] })
                setSelectedDimensionType(0)
            }}
            onSave={(newExtractor) => {
                // Change overall dimensions array
                let isDimensionSelected = (selectedElement["segmentName"] === "")
                let copiedDimensions = dimensions
                let copiedSelectedElement = selectedElement

                copiedSelectedElement["ranges"][selectedRangeIndex]["extractor"] = newExtractor

                if (isDimensionSelected) {
                    for (let x = 0; x < copiedDimensions.length; x++) {
                        if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                            copiedDimensions[x]["ranges"] = copiedSelectedElement["ranges"]
                        }
                    }
                } else {
                    for (let x = 0; x < copiedDimensions.length; x++) {
                        if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                            for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                                if (copiedDimensions[x]["segments"][y]["name"] === copiedSelectedElement["segmentName"]) {
                                    copiedDimensions[x]["segments"][y]["ranges"] = copiedSelectedElement["ranges"]
                                }
                            }
                        }
                    }
                }

                callSetDimensions(copiedDimensions)
                setSelectedElement(copiedSelectedElement)

                if (props.onSave) {
                    props.onSave(copiedDimensions)
                }
            }} />
        <GetExternalSource
            previewData={externalTabData}
            open={externalCellOpen}
            uiColors={props.uiColors}
            getExcelColumnName={props.getExcelColumnName}
            onClose={() => {
                setExternalCellOpen(false)
            }}
            onSave={(newRange) => {
                // Change overall dimensions array
                let isDimensionSelected = (selectedElement["segmentName"] === "")
                let copiedDimensions = dimensions
                let copiedSelectedElement = selectedElement
                let copiedOutputFormatOptions = outputFormatOptions

                copiedOutputFormatOptions.push(`(${newRange["name"]})`)
                copiedSelectedElement["ranges"].push(newRange)
                copiedSelectedElement["outputFormat"].push(`(${newRange["name"]})`)

                if (isDimensionSelected) {
                    for (let x = 0; x < copiedDimensions.length; x++) {
                        if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                            copiedDimensions[x]["ranges"] = copiedSelectedElement["ranges"]
                        }
                    }
                } else {
                    for (let x = 0; x < copiedDimensions.length; x++) {
                        if (copiedDimensions[x]["id"] === copiedSelectedElement["id"]) {
                            for (let y = 0; y < copiedDimensions[x]["segments"].length; y++) {
                                if (copiedDimensions[x]["segments"][y]["name"] === copiedSelectedElement["segmentName"]) {
                                    copiedDimensions[x]["segments"][y]["ranges"] = copiedSelectedElement["ranges"]
                                }
                            }
                        }
                    }
                }

                callSetDimensions(copiedDimensions)
                setSelectedElement(copiedSelectedElement)
                setOutputFormatOptions(copiedOutputFormatOptions)

                if (props.onSave) {
                    props.onSave(copiedDimensions)
                }
            }}
        />
    </>
}

export default AxesDefinition